import { render } from "./ProjectManager.vue?vue&type=template&id=4125c1a3"
import script from "./ProjectManager.vue?vue&type=script&lang=js"
export * from "./ProjectManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__